import React from 'react';
import { KPI, useDates } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const KPISet = ({ dataProviderName, filters: defaultFilters }) => {

    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);

    const { getComparableTimeframe } = useDates();

    return (drawable &&
        <Box className="mtska-kpi-set">
            <KPI
                title="Lead totali"
                icon="faPerson"
                className="highlighted"
                dataProviderName={'statistics/item/count/audiences/audienceLead'}
            />
            <KPI
                title="Totale segmenti creati"
                icon="faLayerGroup"
                dataProviderName={'statistics/item/count/audiences/audienceSegment'}
                filters={filterModel}
            />
            {/* 
            <KPI
                title={"Contatti per segmento"}
                icon="faChartBar"
                dataProviderName={'statistics/currentday/count/audiences/audiencelead'}
                filters={{
                    items: [
                        ...(filterModel?.items || []),
                        ...[
                            {
                                'field': 'registered_at',
                                'operator': 'afterOrEqual',
                                'value': ''
                            }
                        ]
                    ]
                }}
            />
            <KPI
                title={"Segmento più grande"}
                icon="faChartLineUp"
                dataProviderName={'statistics/currentday/count/audiences/audiencelead'}
                filters={{
                    items: [
                        ...(filterModel?.items || []),
                        ...[
                            {
                                'field': 'registered_at',
                                'operator': 'afterOrEqual',
                                'value': ''
                            }
                        ]
                    ]
                }}
            />
            <KPI
                title={"Segmenti attivi"}
                icon="faEye"
                dataProviderName={'statistics/currentday/count/audiences/audiencelead'}
                filters={{
                    items: [
                        ...(filterModel?.items || []),
                        ...[
                            {
                                'field': 'registered_at',
                                'operator': 'afterOrEqual',
                                'value': ''
                            }
                        ]
                    ]
                }}
            /> */}

        </Box>
    )
}

export default KPISet;